window.moment = require('moment');
require('moment-timezone')
require("tempusdominus-bootstrap-4")


window.init_macroevent_datetime_picker = () => {
  
  var basicStartDateTimePickerOptions2 = {
    format: 'DD-MM-YYYY HH:mm',
    showToday: true,
    locale: 'it', // https://github.com/moment/moment/tree/develop/locale
    // timeZone: $('#macro_event_start_dt_dtp').data('timezone'),
    minDate: $('#macro_event_start_dt_dtp').data('mindate'),
    maxDate: $('#macro_event_start_dt_dtp').data('maxdate'),
    date: $('#macro_event_start_dt_dtp').data('datez'),
    debug: false,
    icons: {
      time: 'far fa-clock'
    }
  }
  var basicEndDateTimePickerOptions2 = {
    format: 'DD-MM-YYYY HH:mm',
    showToday: true,
    locale: 'it', // https://github.com/moment/moment/tree/develop/locale
    // timeZone: $('#macro_event_end_dt_dtp').data('timezone'),
    minDate: $('#macro_event_end_dt_dtp').data('mindate'),
    maxDate: $('#macro_event_end_dt_dtp').data('maxdate'),
    date: $('#macro_event_end_dt_dtp').data('datez'),
    debug: false,
    icons: {
      time: 'far fa-clock'
    }
  }
  $('#macro_event_start_dt_dtp').datetimepicker(basicStartDateTimePickerOptions2)
  $('#macro_event_end_dt_dtp').datetimepicker(basicEndDateTimePickerOptions2)


  $('#macro_event_start_dt_dtp').on("change.datetimepicker", ({date, oldDate}) => {
    const t1 = $('#macro_event_start_dt_dtp').datetimepicker('date')
    const t2 = $('#macro_event_end_dt_dtp').datetimepicker('date')
    if (t2<t1) {
      $('#macro_event_end_dt_dtp').datetimepicker('date', t1.add(2, 'hours'))
    }
  })

  $('#macro_event_end_dt_dtp').on("change.datetimepicker", ({date, oldDate}) => {
    const t1 = $('#macro_event_start_dt_dtp').datetimepicker('date')
    const t2 = $('#macro_event_end_dt_dtp').datetimepicker('date')
    if (t2<t1) {
      $('#macro_event_start_dt_dtp').datetimepicker('date', t2.add(-2, 'hours'))
    }
  })
}

document.addEventListener("turbolinks:load", () => {
  
  // when uncheck 'show it' cb, uncheck the 'mandatory' cb
  $(document).on('click', '.participant_field', function() {
    if (!$(this).prop('checked')) {
      targez = $(this).data('targez')
      $("input[name='"+targez+"']").prop('checked', false)
    }
  })
  // when check 'mandatory' cb, check the 'show it' cb
  $(document).on('click', '.participant_mandatory_field', function() {
    if ($(this).prop('checked')) {
      targez = $(this).data('targez')
      $("input[name='"+targez+"']").prop('checked', true)
    }
  })


  var basicStartDateTimePickerOptions = {
    format: 'DD-MM-YYYY HH:mm',
    showToday: true,
    locale: 'it', // https://github.com/moment/moment/tree/develop/locale
    // timeZone: $('#event_start_dt_dtp').data('timezone'),
    minDate: $('#event_start_dt_dtp').data('mindate'),
    maxDate: $('#event_start_dt_dtp').data('maxdate'),
    date: $('#event_start_dt_dtp').data('datez'),
    debug: false,
    icons: {
      time: 'far fa-clock'
    }
  }
  var basicEndDateTimePickerOptions = {
    format: 'DD-MM-YYYY HH:mm',
    showToday: true,
    locale: 'it', // https://github.com/moment/moment/tree/develop/locale
    // timeZone: $('#event_end_dt_dtp').data('timezone'),
    minDate: $('#event_end_dt_dtp').data('mindate'),
    maxDate: $('#event_end_dt_dtp').data('maxdate'),
    date: $('#event_end_dt_dtp').data('datez'),
    debug: false,
    icons: {
      time: 'far fa-clock'
    }
  }

  $('#event_start_dt_dtp').datetimepicker(basicStartDateTimePickerOptions)
  $('#event_end_dt_dtp').datetimepicker(basicEndDateTimePickerOptions)


  function clean_times() {
    // correct end_time (not date!) if it is before start_time
    var startTime = $('#event_start_dt_dtp').datetimepicker('date')
    var endTime   = $('#event_end_dt_dtp').datetimepicker('date')
    // both dates are now equal, so check times
    if (endTime<startTime) {
      $('#event_end_dt_dtp').datetimepicker('date', startTime)
    }
  }


  $('#event_start_dt_dtp').on("change.datetimepicker", ({date, oldDate}) => {
    const t1 = $('#event_start_dt_dtp').datetimepicker('date')
    const t2 = $('#event_end_dt_dtp').datetimepicker('date')
    if (t2<t1) {
      $('#event_end_dt_dtp').datetimepicker('date', t1)
    }
    // $('#event_end_dt_dtp').datetimepicker('minDate', t1)
  })

  $('#event_end_dt_dtp').on("change.datetimepicker", ({date, oldDate}) => {
    const t1 = $('#event_start_dt_dtp').datetimepicker('date')
    const t2 = $('#event_end_dt_dtp').datetimepicker('date')
    if (t2<t1) {
      $('#event_start_dt_dtp').datetimepicker('date', t2)
    }
    // $('#event_end_dt_dtp').datetimepicker('minDate', t1)
  })



  
})
